import React, { useEffect, useState } from "react";
import LoginCard from "../../components/Card/LoginCard";
import myburgoLogo from "../../assets/Logo/myburgoLogoWithTagLine.svg";
import "./LoginPage.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";
import CustomAlert from "../../components/Alerts/CustomAlert";

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showAlert, setShowAlert] = useState(false);
  const [alertData, setAlertData] = useState({});

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
      window.location.reload();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const error = searchParams.get("error");
    if (error) {
      let title = "Login Error";
      let message = "An error occurred during login.";

      switch (error) {
        case "missing_token":
          title = "Missing Token";
          message = "No authentication token was provided.";
          break;
        case "expired_or_invalid":
          title = "Token Expired";
          message =
            "Your login token has expired or is invalid. Please try logging in again.";
          break;
        case "invalid_token":
          title = "Invalid Token";
          message = "The provided token is not valid.";
          break;
        case "token_login_failed":
          title = "Login Failed";
          message = "Token-based login failed. Please try again.";
          break;
        case "server_error":
          title = "Server Error";
          message = "A server error occurred. Please try again later.";
          break;
        case "network":
          title = "Network Error";
          message =
            "Network connection failed. Please check your connection and try again.";
          break;
        default:
          title = "Login Error";
          message = "An unexpected error occurred during login.";
      }

      setAlertData({ title, message });
      setShowAlert(true);

      // Clear the error parameter from URL
      searchParams.delete("error");
      navigate({ search: searchParams.toString() }, { replace: true });
    }
  }, [searchParams, navigate]);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <div className="login-container">
      <div className="login-container-content">
        <img
          src={myburgoLogo}
          alt="my burgo logo"
          className="login-logo-container"
        />
        <LoginCard />
      </div>
      {showAlert && (
        <CustomAlert
          title={alertData.title}
          message={alertData.message}
          onClose={handleCloseAlert}
          autoClose={true}
          type="error"
        />
      )}
    </div>
  );
};

export default LoginPage;
